<template>
  <database-management-modal :element="contract" ref="modal">
    <template v-slot:body>
      <div :class="$hasErrorClass($v.contract.name, 'form-group')">
        <label class="control-label">* Name</label>

        <input
          name="name"
          type="text"
          class="form-control"
          placeholder="Contract name"
          v-model="$v.contract.name.$model" />

        <vuelidate-help :field="$v.contract.name" label="Name" />
      </div>

      <div :class="$hasErrorClass($v.contract.description, 'form-group')">
        <label class="control-label">* Description</label>

        <input
          name="name"
          type="text"
          class="form-control"
          placeholder="Description"
          v-model="$v.contract.description.$model" />

        <vuelidate-help :field="$v.contract.description" label="Description" />
      </div>

      <div :class="$hasErrorClass($v.contract.reset_date, 'form-group')">
        <label class="control-label">* Reset date</label>

        <input
          name="name"
          type="text"
          class="form-control"
          placeholder="22 November"
          v-model="$v.contract.reset_date.$model" />

        <vuelidate-help :field="$v.contract.reset_date" label="Reset date" />
      </div>

      <div :class="$hasErrorClass($v.contract.requirement_name, 'form-group')">
        <label class="control-label">Requirement type</label>

        <selectize
          class="selectize selectize-single form-control"
          name="category"
          :options="requirementOptions"
          v-model="$v.contract.requirement_name.$model"
          :disable-delete="true">
        </selectize>

        <vuelidate-help :field="$v.contract.requirement_name" label="Requirement type" />
      </div>

      <div :class="$hasErrorClass($v.contract.requirement_value, 'form-group')">
        <label class="control-label">* Requirement value</label>

        <input
          name="requirement_value"
          type="number"
          class="form-control"
          placeholder="0"
          v-model="$v.contract.requirement_value.$model" />

        <vuelidate-help :field="$v.contract.requirement_value" label="Requirement value" />
      </div>

      <div :class="$hasErrorClass($v.contract.admin_ids, 'form-group')">
        <label class="control-label">Admins</label>
        <selectize
          ref="admins"
          class="selectize selectize-multiple"
          multiple
          name="admins"
          v-model="contract.admin_ids"
          placeholder="Admins"
          :pre-load="true"
          :options="adminOptions"
          :fetch-results="fetchAdminsCallback"
          :fetch-more-results="fetchMoreAdminsCallback"/>
      </div>
    </template>
    <template v-slot:footer>
      <ladda-button :click="saveContract" type="button" class="btn btn-lg btn-primary pull-right" data-dismiss="modal"><i class="fa fa-check"></i> Save</ladda-button>
    </template>
  </database-management-modal>
</template>

<script>
import {helpers, numeric, required} from 'vuelidate/lib/validators'
import VuelidateHelp from '../../misc/VuelidateHelp'
import Selectize from '../../ext/codium/CodiumSelectize'
import {http, notify} from 'utils'
import DatabaseManagementModal from './templates/DatabaseManagementModal'
import { cloneDeep } from 'lodash'

const dayMonth = helpers.regex('dayMonth', /^[0-9]{1,2} ([jJ]anuary|[fF]ebruary|[mM]arch|[aA]pril|[mM]ay|[jJ]une|[jJ]uly|[aA]ugust|[sS]eptember|[oO]ctober|[nN]ovember|[dD]ecember)$/)

export default {
  components: {DatabaseManagementModal, VuelidateHelp, Selectize},

  data () {
    return {
      adminPagination: {},
      adminOptions: []
    }
  },

  props: {
    contract: {
      required: true
    },
    requirements: {
      required: true
    }
  },

  computed: {
    requirementOptions () {
      return this.requirements.map(element => { return { id: element.type, text: element.name } })
    }
  },

  methods: {

    fetchAdminsCallback (name, callback) {
      return http.get('admin', { params: { name, exclude_deleted: true } }).then(response => {
        this.adminOptions = response.data.data.map(item => {
          return {
            id: Number.parseInt(item.id),
            text: item.name
          }
        })
        this.adminPagination = response.data.meta
        callback(this.adminOptions)
      })
    },

    fetchMoreAdminsCallback (name, callback) {
      if (this.adminPagination && this.adminPagination.current_page < this.adminPagination.last_page) {
        return http.get('admin', { params: { name, page: this.adminPagination.current_page + 1, exclude_deleted: true } }).then(response => {
          const newAdminOptions = cloneDeep(this.adminOptions)
          newAdminOptions.push(...response.data.data.map(item => {
            return {
              id: Number.parseInt(item.id),
              text: item.name
            }
          }))
          this.adminOptions = newAdminOptions
          this.adminPagination = response.data.meta
          callback(this.adminOptions)
        })
      }
      return Promise.resolve()
    },

    closeModal () {
      this.$refs.modal.closeModal()
    },

    saveContract () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }
      const endpoint = this.contract.id ? `contracts/${this.contract.id}/update` : 'contracts/create'
      return http.post(endpoint, this.contract).then((response) => {
        if (!this.contract.id) {
          this.$emit('create', response.data)
        } else {
          this.$emit('update', response.data)
        }
        this.closeModal()
      })
    }
  },

  validations: {
    contract: {
      name: {
        required
      },
      description: {},
      reset_date: {
        dayMonth,
        required
      },
      requirement_value: {
        required,
        numeric
      },
      requirement_name: {
        required
      },
      admin_ids: {}
    }
  }
}
</script>
